'use client'

import { Button } from '@/components/ui/button'
import { useRouter } from 'next/navigation'
import Image from 'next/image'

const AuthErrorMain = ({ message, pageName }: { message?: string; pageName?: string }) => {
  const router = useRouter()

  return (
    <div className='h-full flex flex-col items-center justify-center'>
      <div className='text-[0.95rem] absolute sm:top-64 top-52 text-center text-[#575757]'>
        <div>접속 권한이 없습니다</div>
        <div className='mt-1.5'>
          {message
            ? message
            : '현재 사용 중인 IP는 허용된 목록에 포함되어 있지 않아 접근이 제한되었습니다'}
        </div>
      </div>
      <Image src={'/images/auth.svg'} alt={'error'} width={500} height={500} priority />
      <Button
        variant={'link'}
        className='absolute sm:bottom-64 bottom-52 text-center'
        onClick={() => router.push('/')}
      >
        {pageName ? pageName : '로그인 '}
        페이지로 이동
      </Button>
    </div>
  )
}

export default AuthErrorMain
